module.exports = __webpack_public_path__ + "static/media/1.cdfee752.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16468/1.jpg
// module id = 566
// module chunks = 0